import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CodeComponent } from './code/code.component';
import { DlaComponent } from './dla/dla.component';
import { MvComponent } from './mv/mv.component';
import { SlkComponent } from './slk/slk.component';
import { LuxComponent } from './lux/lux.component';
import { DiscoverComponent } from './discover/discover.component';
import { BlComponent } from './bl/bl.component';
import { AnthemComponent } from './anthem/anthem.component';


const routes: Routes = [

  {
    path: 'code',
    component: CodeComponent,
    children: [
      {path: 'dla', component: DlaComponent},
      {path: 'mv', component: MvComponent},
      {path: 'slk', component: SlkComponent},
      {path: 'lux', component: LuxComponent},
      {path: 'discover', component: DiscoverComponent},
      {path: 'bl', component: BlComponent},
      {path: 'anthem', component: AnthemComponent}
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CodeRoutingModule {} 